module.exports = __webpack_public_path__ + "static/img/patho-cerumen-low-DYOKQYJd.363da60f.png";